import { render } from "./ClientFromOrderForm.vue?vue&type=template&id=7882f830&scoped=true"
import script from "./ClientFromOrderForm.vue?vue&type=script&lang=js"
export * from "./ClientFromOrderForm.vue?vue&type=script&lang=js"

import "./ClientFromOrderForm.vue?vue&type=style&index=0&id=7882f830&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7882f830"]])

export default __exports__